module.exports = __webpack_public_path__ + "img/yinhuanpaicha.d701925d.png";